import { IconBaseProps, IconContext } from "react-icons";
import { AiFillWarning, AiOutlinePauseCircle, AiOutlinePlayCircle } from "react-icons/ai";
import { BsExclamationCircle, BsFillFileEarmarkBarGraphFill, BsFillLockFill, BsFillPencilFill, BsReplyFill, BsSearch, BsXLg } from "react-icons/bs";
import { FaPlus, FaRegMinusSquare, FaRegPlusSquare } from "react-icons/fa";
import { FaCheck, FaCrown, FaFloppyDisk, FaMagnifyingGlass, FaPencil, FaRotate, FaTrashCan, FaUpload, FaXmark } from "react-icons/fa6";
import { HiMenu } from "react-icons/hi";

export const AddIcon = (props: IconBaseProps) => <FaPlus {...props} />

export const CheckIcon = (props: IconBaseProps) => <FaCheck {...props} />

export const CloseIcon = (props: IconBaseProps) => <FaXmark {...props} />

export const DeleteIcon = (props: IconBaseProps) => <FaTrashCan {...props} />

export const RefreshIcon = (props: IconBaseProps) => <FaRotate {...props} />

export const SaveIcon = (props: IconBaseProps) => <FaFloppyDisk {...props} />

export const SearchIcon = (props: IconBaseProps) => <FaMagnifyingGlass {...props} />

//export const TreeCollapseIcon = (props: IconBaseProps) => <FaRegMinusSquare {...props} />
export const TreeCollapseIcon = (props: any) =>
  <IconContext.Provider value={{ color: "#002055", size: "1em", ...props }}>
    <FaRegMinusSquare></FaRegMinusSquare>
  </IconContext.Provider>

//export const TreeExpandIcon = (props: IconBaseProps) => <FaRegPlusSquare {...props} />
export const TreeExpandIcon = (props: any) =>
  <IconContext.Provider value={{ color: "#002055", size: "1em", ...props }}>
    <FaRegPlusSquare></FaRegPlusSquare>
  </IconContext.Provider>


export const ReportIcon = (props: any) =>
  <IconContext.Provider value={{ color: "white", size: "1em", ...props }}>
    <BsFillFileEarmarkBarGraphFill style={{ transform: 'scaleX(-1)' }} />
  </IconContext.Provider>

export const PreviewIcon = (props: any) =>
  <IconContext.Provider value={{ color: "white", size: "1em", ...props }}>
    <BsSearch style={{ transform: 'scaleX(-1)' }} />
  </IconContext.Provider>

export const MoveIcon = (props: any) =>
  <IconContext.Provider value={{ color: "white", size: "1em", ...props }}>
    <BsReplyFill style={{ transform: 'scaleX(-1)' }} />
  </IconContext.Provider>

export const EditIcon = (props: any) =>
  <IconContext.Provider value={{ size: "1em", ...props }}>
    <BsFillPencilFill />
  </IconContext.Provider>

export const CancelIcon = (props: any) =>
  <IconContext.Provider value={{ size: "1em", ...props }}>
    <BsXLg />
  </IconContext.Provider>

export const CheckMarkIcon = (props: any) =>
  <IconContext.Provider value={{ color: "#1A1A1A", style: { 'strokeWidth': '4em' }, ...props }}>
    { props && props.title && <FaCheck title={props.title}></FaCheck> }
    { (!props || !props.title) && <FaCheck></FaCheck>}
  </IconContext.Provider>

export const LockIcon = (props: any) =>
  <IconContext.Provider value={{ color: "white", size: "1em", ...props }}>
    <BsFillLockFill title="Restricted" />
  </IconContext.Provider>

export const InfoIcon = (props: any) =>
  <IconContext.Provider value={{ color: "black", size: "1em", ...props }}>
    <BsExclamationCircle />
  </IconContext.Provider>

export const CrownIcon = (props: any) =>
  <IconContext.Provider value={{ color: "#002055", size: "1em", ...props }}>
    <FaCrown />
  </IconContext.Provider>

export const WarningIcon = (props: any) =>
  <IconContext.Provider value={{ color: "#856404", ...props }}>
    <AiFillWarning size={42} />
  </IconContext.Provider>

export const PauseIcon = (props: any) =>
  <IconContext.Provider value={{ color: "black", size: "1em", ...props }}>
    <AiOutlinePauseCircle />
  </IconContext.Provider>

export const PlayIcon = (props: any) =>
  <IconContext.Provider value={{ color: "black", size: "1em", ...props }}>
    <AiOutlinePlayCircle />
  </IconContext.Provider>

export const PencilIcon = (props: any) =>
  <IconContext.Provider value={{ color: "002055", size: "1em", ...props }}>
    <FaPencil />
  </IconContext.Provider>

export const DnDIcon = (props: any) =>
  <IconContext.Provider value={{ color: "#002055", size: "1em", ...props }}>
    <HiMenu />
  </IconContext.Provider>

export const PublishIcon = (props: any) => <FaUpload {...props}/>


